import React, { Component } from "react";
import Track from "../../components/cabTrackingMap";
import { getWayPoints, getStationFromStationId } from "../../utils/common";
import less from "./track.module.scss";
import moment from "moment";
import { fetchLastLocation, fetchBookingRoute } from "../../network";
class TeamTrack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      bookingId: props.match.params.bookingId,
      busRoute: [],
      tripStatus: null
    };
  }

  async componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      const { tripId, cityId } = this.props.match.params;
      const stateObj = { loading: false };

      const tripDetails = await fetchBookingRoute(tripId);
      stateObj.tripId = tripId;
      stateObj.tripStatus = tripDetails.status;
      stateObj.busRoute = tripDetails.route;

      let filteredCity = tripDetails.route.filter(
        obj => obj.station.cityId === cityId
      );
      const firstStation = tripDetails.route[0].stationId;
      const lastStation = filteredCity[filteredCity.length - 1].stationId;

      stateObj.startPoint = getStationFromStationId(
        firstStation,
        tripDetails.route
      );

      stateObj.endPoint = getStationFromStationId(
        lastStation,
        tripDetails.route
      );

      const checkForTripPassenegerCompleted = tripDetails.route.filter(
        obj => obj.stationId === lastStation
      )[0];

      if (checkForTripPassenegerCompleted.stationMarked === true) {
        stateObj.tripStatus = "COMPLETED";
      }

      switch (stateObj.tripStatus) {
        case "ONTRIP": {
          const lastlocation = await fetchLastLocation(tripId);

          const upcomingStation = getStationFromStationId(
            lastlocation.upcomingStationId,
            tripDetails.route
          );

          stateObj.lastlocation = lastlocation;

          stateObj.upcomingStation = upcomingStation;
          stateObj.wayPoints = getWayPoints(
            tripDetails.route,
            stateObj.startPoint.stationId,
            stateObj.endPoint.stationId
          );
        }
      }

      this.setState(stateObj);
    } catch (error) {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      loading,
      tripId,
      startPoint,
      endPoint,
      lastlocation = {},
      wayPoints,
      tripStatus
    } = this.state;
    if (loading) {
      return <h1>...Loading</h1>;
    }

    if (tripStatus === "ACTIVE") {
      return (
        <div className={less.unavailableWrapper}>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/cabTracking/trackingActive.svg"
            alt="trackingUnavailable"
          />
          <p>Tracking unavailable</p>
          <span>Please check back shortly</span>
        </div>
      );
    } else if (tripStatus === "COMPLETED") {
      return (
        <div className={less.unavailableWrapper}>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/cabTracking/trackingActive.svg"
            alt="trackingUnavailable"
          />
          <p>Tracking unavailable</p>
          <span>Bus Already Reached The Station</span>
        </div>
      );
    } else if (!lastlocation.coordinates) {
      return (
        <div className={less.unavailableWrapper}>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/cabTracking/trackingUnavailable.svg"
            alt="trackingUnavailable"
          />
          <p>Unable to retrieve tracking data</p>
          <span>Please try again later</span>
        </div>
      );
    }

    return (
      <div className={less.wrapper}>
        <Track
          tripId={tripId}
          startPoint={startPoint}
          endPoint={endPoint}
          lastPoint={lastlocation}
          path={wayPoints}
        />
        <div className={less.statusWrapper}>
          <span className={less.statusText}>
            Last updated at {moment(lastlocation.latlngDate).format("hh:mm A")}
          </span>
        </div>
      </div>
    );
  }
}

export default TeamTrack;
